import React from "react";
import { Box } from "@mui/material";

import genericIcon from "../../assets/icons/fileCabinet/generic.svg";
import csvIcon from "../../assets/icons/fileCabinet/csv.svg";
import docxIcon from "../../assets/icons/fileCabinet/docx.svg";
import docIcon from "../../assets/icons/fileCabinet/doc.svg";
import pubIcon from "../../assets/icons/fileCabinet/pub.svg";
import txtIcon from "../../assets/icons/fileCabinet/txt.svg";
import xslIcon from "../../assets/icons/fileCabinet/xsl.svg";
import pptIcon from "../../assets/icons/fileCabinet/ppt.svg";
import mdbIcon from "../../assets/icons/fileCabinet/mdb.svg";
import zipIcon from "../../assets/icons/fileCabinet/zip.svg";
import rarIcon from "../../assets/icons/fileCabinet/rar.svg";
import isoIcon from "../../assets/icons/fileCabinet/iso.svg";
import exeIcon from "../../assets/icons/fileCabinet/exe.svg";
import dllIcon from "../../assets/icons/fileCabinet/dll.svg";
import psdIcon from "../../assets/icons/fileCabinet/psd.svg";
import aiIcon from "../../assets/icons/fileCabinet/ai.svg";
import psIcon from "../../assets/icons/fileCabinet/ps.svg";
import crdIcon from "../../assets/icons/fileCabinet/crd.svg";
import svgIcon from "../../assets/icons/fileCabinet/svg.svg";
import epsIcon from "../../assets/icons/fileCabinet/eps.svg";
import dwgIcon from "../../assets/icons/fileCabinet/dwg.svg";
import bmpIcon from "../../assets/icons/fileCabinet/bmp.svg";
import jpgIcon from "../../assets/icons/fileCabinet/jpg.svg";
import tiffIcon from "../../assets/icons/fileCabinet/tiff.svg";
import rawIcon from "../../assets/icons/fileCabinet/raw.svg";
import pngIcon from "../../assets/icons/fileCabinet/png.svg";
import gifIcon from "../../assets/icons/fileCabinet/gif.svg";
import flvIcon from "../../assets/icons/fileCabinet/flv.svg";
import aviIcon from "../../assets/icons/fileCabinet/avi.svg";
import mpegIcon from "../../assets/icons/fileCabinet/mpeg.svg";
import movIcon from "../../assets/icons/fileCabinet/mov.svg";
import mp4Icon from "../../assets/icons/fileCabinet/mp4.svg";
import wmaIcon from "../../assets/icons/fileCabinet/wma.svg";
import mp3Icon from "../../assets/icons/fileCabinet/mp3.svg";
import midIcon from "../../assets/icons/fileCabinet/mid.svg";
import wavIcon from "../../assets/icons/fileCabinet/wav.svg";
import javaIcon from "../../assets/icons/fileCabinet/java.svg";
import rssIcon from "../../assets/icons/fileCabinet/rss.svg";
import xmlIcon from "../../assets/icons/fileCabinet/xml.svg";
import htmlIcon from "../../assets/icons/fileCabinet/html.svg";
import hmmIcon from "../../assets/icons/fileCabinet/hmm.svg";
import urlIcon from "../../assets/icons/fileCabinet/url.svg";

interface Props {
  title?: string;
  extension?: string;
}


export const DocumentIcon = ({ title, extension }: Props): JSX.Element => {
  const info = getIconInfoForExtension(extension || "")

  return (
    <Box style={{ width: "100px", position: "relative" }}>
      <img
        style={{ display: "flex", maxWidth: "100%", maxHeight: "100%" }}
        src={info.src}
        alt={title}
        title={title}
      />
      {info.imageIsMissingExtension && <Box
        sx={{
          position: "absolute",
          bottom: "9px",
          right: "20px",
          color: "white",
          fontWeight: 800,
          fontSize: 20,
          width: "50px",
        }}
      >
        {extension?.substring(0, 4)}
      </Box>}
    </Box>
  );
};


export function getIconInfoForExtension(extension: string): { src: string, imageIsMissingExtension?: boolean } {
  const ext = extension.toLowerCase().replaceAll(".", "")
  switch (ext) {
    case "csv":
    case "text/csv":
      return { src: csvIcon }
    case "docx":
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document".replaceAll(".", ""):
      return { src: docxIcon }
    case "doc":
    case "application/msword":
      return { src: docIcon }
    case "pub":
    case "application/x-mspublisher":
      return { src: pubIcon }
    case "txt":
    case "text/plain":
      return { src: txtIcon }
    case "xsl":
    case "application/xml":
    case "text/xml":
      return { src: xslIcon }
    case "ppt":
    case "application/vnd.ms-powerpoint".replaceAll(".", ""):
      return { src: pptIcon }
    case "mdb":
    case "application/x-msaccess":
      return { src: mdbIcon }
    case "zip":
    case "application/x-zip-compressed":
      return { src: zipIcon }
    case "rar":
    case "application/vnd.rar".replaceAll(".", ""):
    case "application/x-compressed":
      return { src: rarIcon }
    case "iso":
    case "application/x-iso9660-image":
      return { src: isoIcon }
    case "exe":
    case "application/x-msdownload":
      return { src: exeIcon }
    case "dll":
      //case "application/x-msdownload":
      return { src: dllIcon }
    case "psd":
    case "image/vnd.adobe.photoshop".replaceAll(".", ""):
      return { src: psdIcon }
    case "ai":
    case "application/postscript":
      return { src: aiIcon }
    case "ps":
      // case "application/postscript":
      return { src: psIcon }
    case "crd":
    case "application/x-mscardfile":
      return { src: crdIcon }
    case "svg":
    case "image/svg+xml":
      return { src: svgIcon }
    case "eps":
      // case "application/postscript":
      return { src: epsIcon }
    case "dwg":
    case "mage/vnd.dwg".replaceAll(".", ""):
      return { src: dwgIcon }
    case "bmp":
    case "image/bmp":
      return { src: bmpIcon }
    case "jpg":
    case "image/jpeg":
      return { src: jpgIcon }
    case "tiff":
    case "image/tiff":
      return { src: tiffIcon }
    case "raw":
    case "image/x-panasonic-raw":
      return { src: rawIcon }
    case "png":
    case "image/png":
      return { src: pngIcon }
    case "gif":
    case "image/gif":
      return { src: gifIcon }
    case "flv":
    case "video/x-flv":
      return { src: flvIcon }
    case "avi":
    case "video/x-msvideo":
      return { src: aviIcon }
    case "mpeg":
    case "video/mpeg":
      return { src: mpegIcon }
    case "mov":
    case "video/quicktime":
      return { src: movIcon }
    case "mp4":
    case "video/mp4":
      return { src: mp4Icon }
    case "wma":
    case "audio/x-ms-wma":
      return { src: wmaIcon }
    case "mp3":
    case "audio/mpeg":
      return { src: mp3Icon }
    case "mid":
    case "audio/midi":
      return { src: midIcon }
    case "wav":
    case "audio/vnd.wav".replaceAll(".", ""):
      return { src: wavIcon }
    case "java":
    case "text/x-java-source":
      return { src: javaIcon }
    case "rss":
    case "application/rss+xml":
      return { src: rssIcon }
    case "xml":
      // case "application/xml":
      return { src: xmlIcon }
    case "html":
    case "text/html":
      return { src: htmlIcon }
    case "hmm":
      return { src: hmmIcon }
    case "url":
      return { src: urlIcon }
    default:
      return {
        src: genericIcon,
        imageIsMissingExtension: true,
      }
  }
}